<template>
  <CCard class="statistical-card auction-statistical-card">
    <CCardHeader
      color="white"
      border-color="white"
      class="auction-statistical-card__legend"
    >
      <div class="auction-statistical-card__legend-revenue">
        Sales Revenue
      </div>
    </CCardHeader>
    <CCardBody
      color="white"
      border-color="white"
      class="auction-statistical-card__body"
    >
      <CChartBarRounded
        class="auction-statistical-card__chart-wrapper"
        :labels="barsConfig.labels"
        :datasets="barsConfig.datasets"
        :options="barsConfig.options"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import { CChartBarRounded } from "@/charts";
import {
  createStatisticalMixin,
  statisticalStore
} from "@/mixins/statisticalMixin";

const barsColor = "#109CF1";
const textColor = "#BBBCC1";
const fontFamily = "Poppins";

const gridColor = "#E9ECEF";
const gridLineWidth = 2;
const gridZeroLineColor = "#E9ECEF";
const gridZeroLineWidth = 2;

const barsStyle = {
  backgroundColor: barsColor,
  hoverBackgroundColor: barsColor,
  hoverBorderColor: barsColor
};

const textStyle = {
  fontFamily: fontFamily,
  fontColor: textColor
};

const gridStyles = {
  color: gridColor,
  lineWidth: gridLineWidth,
  zeroLineColor: gridZeroLineColor,
  zeroLineWidth: gridZeroLineWidth
};

export default {
  name: "VAuctionsStatisticalCard",

  components: {
    CChartBarRounded
  },

  props: {
    labels: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [createStatisticalMixin()],

  computed: {
    revenueCounts() {
      return (this[statisticalStore.getterTypes.GET_CHARTS] || {})
        .revenueCounts;
    },
    dataset() {
      return (
        (this.revenueCounts && this.revenueCounts.map(rc => rc.revenue)) || []
      );
    },
    computedLabels() {
      return this.labels.labels.length
        ? this.labels.labels
        : (this.revenueCounts && this.revenueCounts.map(a => a.period)) || [];
    },
    barsConfig() {
      return {
        labels: [...this.computedLabels],
        datasets: [
          {
            label: "Sales Revenue",
            barPercentage: 0.15,
            categoryPercentage: 1,
            maxBarThickness: 15,
            data: this.dataset || [],
            ...barsStyle
          }
        ],
        options: {
          layout: {
            padding: {
              top: 50
            }
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: false,
                  drawTicks: false,
                  color: "transparent"
                },
                ticks: {
                  display: true,
                  padding: 15,
                  callback: this.labels.formatCallback,
                  ...textStyle
                }
              }
            ],
            yAxes: [
              {
                type: "extendedScale",
                display: true,
                gridLines: {
                  display: true,
                  drawTicks: false,
                  ...gridStyles
                },
                ticks: {
                  min: 0,
                  stepSize: this.labels.stepSize.revenue,
                  display: true,
                  beginAtZero: true,
                  padding: 10,
                  ...textStyle,
                  callback: value => {
                    if (value < 1000) return value;
                    return `${Math.round(value / 100) / 10}K`;
                  }
                }
              }
            ]
          }
        }
      };
    }
  }
};
</script>
